import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextRotation = /** @class */ (function (_super) {
    __extends(TextRotation, _super);
    function TextRotation() {
        return _super.call(this) || this;
    }
    TextRotation.forceNativeConstructor = true;
    TextRotation.forceNativeMethods = true;
    // JS -> AS Bindings
    TextRotation.ROTATE_0 = 'rotate0';
    TextRotation.ROTATE_90 = 'rotate90';
    TextRotation.ROTATE_180 = 'rotate180';
    TextRotation.ROTATE_270 = 'rotate270';
    TextRotation.AUTO = 'auto';
    return TextRotation;
}(ASObject));
export { TextRotation };
